import { render } from "./CreationCard.vue?vue&type=template&id=18c30e4b&scoped=true"
import script from "./CreationCard.vue?vue&type=script&lang=js"
export * from "./CreationCard.vue?vue&type=script&lang=js"

import "./CreationCard.vue?vue&type=style&index=0&id=18c30e4b&scoped=true&lang=css"

import exportComponent from "/home/oat/Desktop/ordi/corridor_v2/corridor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c30e4b"]])

export default __exports__